/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getSearchFilterConfigRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getSearchFilterConfig',
  auth: 'external',
  fingerprint: '4oEIKcmmEbnNEoqF3bTpaZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};